import { useState } from 'react';
import axios from 'axios';
import { enableFrontdoor } from '../Utils/features';

const BASE_URL = enableFrontdoor ? process.env.REACT_APP_PRICER_API_BASE_URL_FRONTDOOR : process.env.REACT_APP_PRICER_API_BASE_URL;

export default function usePricerApi(modelType) {
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [result, setResult] = useState(null);

    const executeRequest = async (year, request) => {
        setLoading(true);
        setSuccess(false);
        setError(null);
        setResult(null);
        
        try {
            const { data } = axios.post(`${BASE_URL}/api/${modelType}/${year}`, { ...request });

            setResult(data);
            setSuccess(true);
        } catch (e) {

            setError(e);
        } finally {
            setLoading(false);
        }
    };

    const executeReset = () => {
        setLoading(false);
        setSuccess(false);
        setError(null);
        setResult(null);
    }

    return {
        loading,
        success,
        error,
        result,
        execute: executeRequest,
        reset: executeReset
    };
}